import { render, staticRenderFns } from "./FormUpdateForm.vue?vue&type=template&id=c2af9f02&"
import script from "./FormUpdateForm.vue?vue&type=script&lang=js&"
export * from "./FormUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports